import { useState } from "react";
import { MessageSquare, X } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { usePortal } from "./PortalContext";

// One dialog for both "Message TAG" (account-level) and "Message TAG about this request" (evaluation-level).
export const MessageTagButton = ({ evaluationId = null, label = "Message TAG", className = "cp-btn cp-btn-outline", testId = "message-tag" }) => {
  const portal = usePortal();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function send(event) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const path = evaluationId ? `/client-portal/evaluations/${evaluationId}/message` : "/client-portal/messages";
      const response = await api.post(path, { message });
      toast.success(response.data.message || "Message sent to TAG");
      setMessage("");
      setOpen(false);
    } catch (requestError) {
      setError(formatApiError(requestError));
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <button type="button" className={className} data-testid={`${testId}-button`} onClick={() => { setOpen(true); setError(""); }}><MessageSquare size={14} /> {label}</button>
      {open && (
        <div className="cp-modal-backdrop" role="presentation" onClick={() => setOpen(false)}>
          <form className="cp-modal" role="dialog" aria-modal="true" data-testid={`${testId}-dialog`} onClick={(e) => e.stopPropagation()} onSubmit={send}>
            <header>
              <h3>{evaluationId ? "Message TAG about this request" : "Message TAG"}</h3>
              <button type="button" className="cp-icon-button" aria-label="Close" data-testid={`${testId}-close`} onClick={() => setOpen(false)}><X size={16} /></button>
            </header>
            <p className="cp-muted">Your message goes to {portal.account?.tag_contact?.name || "your TAG contact"} and the TAG operations team.</p>
            {portal.preview && <p className="cp-inline-note" data-testid={`${testId}-preview-note`}>Messages are disabled in client view preview.</p>}
            <textarea value={message} rows={5} maxLength={2000} placeholder="Write your message…" data-testid={`${testId}-input`} onChange={(e) => setMessage(e.target.value)} disabled={portal.preview} />
            {error && <p className="cp-error" data-testid={`${testId}-error`}>{error}</p>}
            <footer>
              <button type="button" className="cp-btn cp-btn-ghost" onClick={() => setOpen(false)}>Close</button>
              <button type="submit" className="cp-btn cp-btn-primary" data-testid={`${testId}-send`} disabled={busy || portal.preview || message.trim().length < 2}>{busy ? "Sending…" : "Send message"}</button>
            </footer>
          </form>
        </div>
      )}
    </>
  );
};
